import * as angular from "angular";
import {PredefinedSkillType} from "../types/predefined-skill.type";

angular
  .module('bringoz.admin.skills')
  .filter('skillName', skillName);

function skillName($translate) {
  return function skillNameFunction(name) {

    if (!name) {
      return;
    }

    if (name === PredefinedSkillType.Delivery ||
      name === PredefinedSkillType.Merchandise ||
      name === PredefinedSkillType.Order) {
      return $translate.instant(`SKILLS.${name}`);
    } else {
      return name;
    }

  }
}
